import { actions as groupActions } from 'containers/Group';

export function isUnlockHomeworksUnlockable(unlockHomeworks) {
  return unlockHomeworks.some((unlockHomework) => unlockHomework.manualLessonSequence &&
      unlockHomework.manualLessonSequence <= unlockHomework.totalLessonAmount &&
      unlockHomework.manualLessonSequence > unlockHomework.latestUnlockedSequence);
}

export function getUnlockHomeworksByGroup(state, groupId) {
  return state.get('rootReducer').get('unlockHomework').get(`${groupId}`);
}

export function canEditUnlockHomework(state, groupId) {
  return ! groupActions.hasContentPath(state, groupId);
}



// WEBPACK FOOTER //
// ./data/UnlockHomework/accessors.js